<template lang="html">

  <div class="enoturismo">

    <section class="banner-intro full-view-intro -middle column-center animation brown" data="enoturismo">

      <h1 class="title -intro">
        {{ $t('vistas.enoturismo') }}
      </h1>

      <h2 class="subtitle-intro">
        <router-link :to="$t('enlaces.vive_aldonza')">{{ $t('vistas.vive_aldonza') }}</router-link>
      </h2>

    </section>

    <section class="intro-experiencias animation">

      <router-link :to="$t('enlaces.vive_aldonza') + '#' + $t('banners_experiencia.enoturismo.id')" class="back">
        {{ $t('volver') }}</router-link>

      <h2 class="title -xs -xxs container">{{ $t('banners_experiencia.enoturismo.titulo_intro_experiencia') }}</h2>

      <div class="tips-bodega container row-center ais">

        <article class="tip-el" v-for="el in $t('banners_experiencia.enoturismo.tips_bodega')">
          <h3 class="title -xs">{{ el.titulo }}</h3>
          <p>{{ el.cuerpo }}</p>
          <a :href="$t('enlaces.mejor_bodega_CM')" target="_blank">
            <u style="font-weight: 500;">{{ $t('mejor_bodega_CM') }}</u>
          </a>
        </article>

      </div>

    </section>

    <section class="la-visita animation ">

      <div class="container row-start ais">

        <div class="textos">

          <h2 class="title">{{ $t('banners_experiencia.enoturismo.la_visita_text') }}</h2>

          <template v-for="el in $t('banners_experiencia.enoturismo.la_visita')">
            <p>{{ el.cuerpo }}</p>

          </template>
            <p>
              <a class="imagen-trip" target="_blank"
              href="https://www.tripadvisor.es/Attraction_Review-g1437533-d15780377-Reviews-Bodegas_Aldonza-Munera_Province_of_Albacete_Castile_La_Mancha.html">
                <img src="/static/img/tripadvisor-blanco.png" alt="" class="tripadvisor">
              </a>
            </p>
        </div>

        <tour-bodega></tour-bodega>

      </div>

    </section>

    <section class="contenedor-formulario animation">
      <formulario-experiencias where="enoturismo" id="formulario"></formulario-experiencias>
    </section>

    <div class="contenedor-banner-localizaciones animation">

      <banner-localizaciones></banner-localizaciones>

    </div>

    <div class="banner-experiencia animation">

      <experiencia-bodega></experiencia-bodega>

    </div>

    <section class="video-spot animation">

      <div class="wrapper-spot row-center container ais">

        <article class="contenedor-textos">

          <h2 class="title">{{ $t('banners_experiencia.enoturismo.video.titulo') }}</h2>

          <p v-html="$t('banners_experiencia.enoturismo.video.cuerpo')"></p>

        </article>

        <article class="contenedor-video" @click="show_video = true">
          <a class="enlace-cover row-center">
            <img src="/static/img/play.svg" width="80" alt="">
          </a>
        </article>

      </div>

    </section>

    <div class="contenedor-otras-experiencias animation">
      <otras-experiencias></otras-experiencias>
    </div>

    <video-visualizer :show="show_video" :id="video_id" @closeVideo="closeVideo"></video-visualizer>


  </div>

</template>

<script lang="js">

import formularioExperiencias from '@/components/views/experiencias/formulario-experiencias';
import bannerLocalizaciones from '@/components/views/experiencias/banner-localizaciones'
import experienciaBodega from '@/components/views/experiencias/experiencia-bodega';
import otrasExperiencias from '@/components/parts/otras-experiencias';

import videoVisualizer from '@/components/parts/video-visualizer'

import tourBodega from '@/components/views/experiencias/tour-bodega';

export default {
  name: 'enoturismo',
  components: {
    'formulario-experiencias': formularioExperiencias,
    'banner-localizaciones': bannerLocalizaciones,
    'experiencia-bodega': experienciaBodega,
    'otras-experiencias': otrasExperiencias,
    'video-visualizer': videoVisualizer,
    'tour-bodega': tourBodega
  },
  data() {
    return {
      show_video: false,
      video_id: "t8E7sXCh6gQ?start=10"
    }
  },
  methods: {
    closeVideo: function () {
      this.show_video = false
    }
  },
  watch: {
    'show_video': function () {
      this.video_id = (this.show_video) ? "t8E7sXCh6gQ?start=10" : null;
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/colors.scss";

.full-view-intro[data=enoturismo] {
  background: url("/static/img/enoturismo/background-intro-enoturismo.jpg") center/cover no-repeat;
}

.title.-intro {
  overflow: visible;
  height: auto;
}

.intro-experiencias {
  background: $mud-brown;

}

.tips-bodega {
  margin-top: 75px;
  overflow: hidden;
}

.tripadvisor {
  width: 100px;
  padding-top: 30px;
  float: left
}



.tip-el {
  width: 100%;
  max-width: 768px;
  margin-bottom: 60px;

  opacity: 0;
  transform: translateY(600px);
  transition: 1s;
  transition-timing-function: ease;

  .title {
    text-align: left;
    padding-bottom: 10px;

    &::before {
      display: inline-block;
    }
  }

  p {
    text-align: justify;
  }

}


@for $i from 1 through 2 {
  .tip-el:nth-child(#{$i}) {
    transition-delay: #{$i / 10 + 1}s;
  }
}

@for $i from 3 through 4 {
  .tip-el:nth-child(#{$i}) {
    transition-delay: #{$i / 10 + 1.1}s;
  }
}

.la-visita {
  padding: 100px 0;
  padding-bottom: 200px;
  background: $plum;
  overflow: hidden;

  .textos {
    width: 50%;
    padding-right: 100px;
    overflow: hidden;

    .title {
      transform: translateY(-100px);
      transition: 1s;
      opacity: 0;
    }

    p {
      text-align: justify;
      transform: translateY(100vh);
      opacity: 0;
      transition: 1.5s;
    }

    @for $i from 1 through 8 {
      p:nth-child(#{$i}) {
        transition-delay: #{$i / 10 + .4}s;
      }
    }

  }

  .contenedor-imagen {
    width: 50%;
    height: calc(#{$container-width} / 2);
    background: url('/static/img/foto-tour-bodega.jpg') center no-repeat;
    display: inline-block;
    position: relative;
    opacity: 0;
    transition-duration: .5s;
    /*transition-delay: 2s;*/
    transition-timing-function: ease;
    transform: translateY(-100%);
  }

}

.contenedor-formulario {
  background: url("/static/img/enoturismo/background-formulario.jpg") center/cover no-repeat;
  display: inline-block;
  width: 100%;
}

.video-spot {
  widows: 100%;
  background: $plum;
  padding: 100px 0;

  .wrapper-spot {
    overflow: hidden;


    .contenedor-textos {

      width: 50%;
      padding-right: 100px;

      .title {
        transform: translateY(-100px);
        opacity: 0;
        transition: 1s;
      }

      p {
        text-align: justify;
        transform: translateY(300px);
        opacity: 0;
        transition: 1s;
        transition-delay: .5s;
      }
    }

    .contenedor-video {
      width: 50%;
      height: calc((#{$container-width} / 2) * 9 / 16);
      background: url("/static/img/enoturismo/background-formulario.jpg") center/cover no-repeat;
      display: inline-block;
      position: relative;
      transform: translateY(400px);
      opacity: 0;
      transition: 1s;


      .enlace-cover {
        background: rgba(0, 0, 0, 0.6);
      }

    }
  }
}

.launched {

  >.title {
    opacity: 1;
    transform: translateY(0);
  }

  .tip-el {
    opacity: 1;
    transform: translate(0);
  }

  &.la-visita {

    .title,
    p {
      transform: translate(0);
      opacity: 1;
    }

    .contenedor-imagen {
      opacity: 1;
      transform: translate(0);
    }
  }

  &.video-spot {

    .wrapper-spot {

      .contenedor-textos {

        .title,
        p {
          opacity: 1;
          transform: translate(0);
        }

      }

      .contenedor-video {
        opacity: 1;
        transform: translateY(0);
      }

    }

  }

}

@media screen and (max-width: 769px) {
  .tip-el {
    width: 100%;
  }

  .la-visita {
    .textos {
      padding-right: 0;
      width: 100%;
      margin-bottom: 50px;
    }

    .contenedor-imagen {
      width: 100%;
    }
  }

  .video-spot {
    padding: 50px 0;

    .wrapper-spot {
      .contenedor-textos {
        padding-right: 0;
        width: 100%;
      }

      .contenedor-video {
        width: 100%;
        margin-top: 30px;
      }
    }
  }

}

@media screen and (max-width: 600px) {
  .tips-bodega {
    margin-top: 25px;
    padding: 0;

    .tip-el {
      margin-bottom: 25px;
    }
  }

  .la-visita {
    padding: 50px 0;
    padding-bottom: 150px;

    .contenedor-imagen {
      height: 90vw;

      .contenedor-flechas {
        transform: scale(.8);
        top: 10px;
        left: 10px;
      }
    }
  }

  .video-spot {
    padding-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/experiencias/enoturismo.vue